webpackJsonp([142629428675168],{

/***/ 388:
/***/ (function(module, exports) {

	module.exports = {"data":{"allHomeJson":{"edges":[{"node":{"launchscreens":[{"image":"/images/uploads/av-h.jpg"}]}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-b08264acae26aa81cf0d.js